import React ,{useEffect} from 'react';
import AOS from 'aos';
import Features from '../Components/Pages/Home/Features';
import Innovative from '../Components/Pages/Home/Innovative';
import Banner from '../Components/Pages/MobileApp/Banner';
import Features1 from '../Components/Pages/MobileApp/Features';
import Header from '../Components/Shared/Header/Header';
import Jobs from '../Components/Pages/AboutUs/Jobs';
import Start from '../Components/Shared/Start/Start';
import Footer from '../Components/Shared/Footer/Footer';
import Frame from '../Components/Pages/MobileApp/Frame';
import Design from '../Components/Pages/MobileApp/Design';
import Section from '../Components/Pages/MobileApp/Section';
import FaqApp from '../Components/Shared/FaqApp/FaqApp';
import Slider from '../Components/Shared/LogoSlider/Slider';
import { images } from '../Components/Pages/Home/data';
function MobileApp(){
  useEffect(() => {
    AOS.init({
      duration: 800,
      disable: 'mobile',
      once: true,
    });
  }, []);
    return(
        <>
        <Header />
        <Banner />
        <Frame />
      <Features1 />
      <Innovative />
      <Section />
      <Design />
      <FaqApp />
        <Slider list={images}  styles="nobg-slider"/>
      <Features />
      <Jobs />
      <Start />
      <Footer/>
        </>
    )
};
export default MobileApp ;